import HeaderLogoContainer from './HeaderLogoContainer.js';
export default HeaderLogoContainer;
//# sourceMappingURL=index.js.map